export default __webpack_public_path__ + "static/media/Login-background-arrows.de76ccf9.svg";